import { HttpEventType } from '@angular/common/http';
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { Validators, FormBuilder } from '@angular/forms';
import { MatDialog, MatSnackBar } from '@angular/material';
import { LanguageService } from 'app/_services/language.service';
import { UploadFileService } from 'app/_services/upload-file.service';
import { LoadingFileDialogComponent } from '../loading-file-dialog/loading-file-dialog.component';
import { ServiceAccountCodeModalComponent } from '../service-account-code-modal/service-account-code-modal.component';

@Component({
  selector: 'fury-indexing-video',
  templateUrl: './indexing-video.component.html',
  styleUrls: ['./indexing-video.component.scss']
})
export class IndexingVideoComponent implements OnInit {
  public uploadedFilesVideo: string[] = [];
  objectKeys = Object.keys;
  itaLang: string = 'it-IT';
  enLang: string = 'en-US';

  private serviceAccountValidatorsFGStorageLink = [];

  public formGroupStorageLink = this.fb.group({
    link: [null, Validators.required],
    lang: [this.itaLang],
    isPrivateBucket: [false],
    featureTypeCodes: [null, Validators.required],
    serviceAccount: ['', this.serviceAccountValidatorsFGStorageLink]
  });

  public formGroupFiles = this.fb.group({
    file: ['', Validators.required],
    lang: [this.itaLang],
    featureTypeCodes: [null, Validators.required]
  });



  @ViewChild("fileUploaderVideo")
  fileUpload: ElementRef;
  files = [];
  dialogRef;
  sendLinkIsLoading: boolean = false;
  visionApiList: string[] = [];
  constructor(private fb: FormBuilder,
    private uploadFileService: UploadFileService,
    private dialog: MatDialog,
    private snackBarVideo: MatSnackBar,
    public languageService: LanguageService
  ) { }

  ngOnInit() {
    this.onValueFormChange();
    this.getFeatureTypes();
  }

  getFeatureTypes(){
    this.uploadFileService.getFeatureTypesVideo().subscribe((res) =>{
      this.visionApiList = res.body;
    })
  }

  get formGroupFilesLang() { return this.formGroupFiles.get('lang').value; }
  get formGroupStorageLinkLang() { return this.formGroupStorageLink.get('lang').value; }

  public onFileChange(event) {
    const formData: any = new FormData();
    let filesNames: string[] = [];
    formData.append('lang', this.formGroupFiles.value.lang);
    if (event.target.files && event.target.files.length) {
      Array.from(event.target.files).forEach((file: File) => {
        formData.append('files', file);
        filesNames.push(file.name)
      });
      formData.append('features', this.formGroupFiles.value.featureTypeCodes);
      this.dialogRef = this.dialog.open(LoadingFileDialogComponent, { width: '380px', disableClose: true });
      this.dialogRef.componentInstance.percentage = 0;
      this.dialogRef.componentInstance.currentFile = filesNames[0];

      this.uploadFileService.uploadVideoFiles(formData).subscribe(

        eventResp => {
          switch (eventResp.type) {
            case HttpEventType.UploadProgress: {
              const percentDone = Math.round(100 * eventResp.loaded / eventResp.total);
              this.dialogRef.componentInstance.percentage = percentDone
              let currentFilesIndex = Math.round((filesNames.length * percentDone / 100))
              this.dialogRef.componentInstance.currentFile = filesNames[currentFilesIndex];
              break;
            }
            case HttpEventType.Response: {
              
              if (eventResp.status === 200) {
                this.showSuccessToastVideo();
                this.formGroupFiles.reset();
                this.formGroupFiles.controls.lang.setValue(this.itaLang);
              } else {
                this.showErroToast('general.serviceError');
              }
              this.dialog.closeAll();
              break;
            }
            default: {
              console.log(event);
            }
          }
        },
        err => {
          this.showErroToast('general.serviceError');
          this.dialog.closeAll();
          console.error(err)
        },
      )
    }
  }

  public onSubmitStorageLinkVideo() {
    const formData = new FormData();
    this.sendLinkIsLoading = true;
    formData.append('externalUrl', this.formGroupStorageLink.value.link.trim());
    formData.append('lang', this.formGroupStorageLink.value.lang);
    formData.append('serviceAccount', this.formGroupStorageLink.value.serviceAccount);
    formData.append('isPrivateBucket', (this.formGroupStorageLink.value.isPrivateBucket !== null ? this.formGroupStorageLink.value.isPrivateBucket : false))
    formData.append('features', this.formGroupStorageLink.value.featureTypeCodes);

    this.uploadFileService.sendStorageLinkVideo(formData).subscribe(
      resp => {
        if (resp.type === HttpEventType.Response) {
          if(resp.status === 200){
            this.formGroupStorageLink.value.link = '';
            this.sendLinkIsLoading = false;
            this.formGroupStorageLink.reset();
            this.formGroupStorageLink.controls.lang.setValue(this.itaLang);
            this.showSuccessToastVideo();
          }else{
            this.showErroToast('general.serviceError');
          }
        }
      },
      err => {
        this.sendLinkIsLoading = false;
        switch (err.status) {
          case 403: {
            this.showErroToast('index-video.noPublicBucket');
            break;
          }
          default: {
            this.showErroToast('general.serviceError');
          }
        }
      })
  }

  private showSuccessToastVideo() {
    this.snackBarVideo.open(
      this.languageService.getLabel('index-file.operationStarted'),
      'OK',
      {
        duration: 15000,
        horizontalPosition: 'center'
      }
    );
  }
  private showErroToast(error) {
    this.snackBarVideo.open(
      this.languageService.getLabel(error),
      'OK',
      {
        duration: 10000,
        horizontalPosition: 'center'
      }
    );
  }
  showServiceAccountModal(formType) {
    const _this = this
    const serviceAccountDialog = this.dialog.open(ServiceAccountCodeModalComponent, {
      width: '500px'
    });
    serviceAccountDialog.afterClosed().subscribe(
      data => {
        formType.controls.serviceAccount.setValue(data)
      }
    );
  }

  onValueFormChange(){
    this.formGroupStorageLink.get('isPrivateBucket').valueChanges
    .subscribe(value => {
      if(value) {
        this.formGroupStorageLink.get('serviceAccount').setValidators(this.serviceAccountValidatorsFGStorageLink.concat(Validators.required))
      } else {
        this.formGroupStorageLink.get('serviceAccount').setValidators(this.serviceAccountValidatorsFGStorageLink)
      }
      this.formGroupStorageLink.get('serviceAccount').updateValueAndValidity();
      this.formGroupStorageLink.updateValueAndValidity();
    });
  }

  setIsPrivateBucket(event){
    this.formGroupStorageLink.controls['isPrivateBucket'].setValue(event)
  }

    /*checkbox change event*/
  onChange(event) {
        // This is intentional
  }
}
